module.exports = __webpack_public_path__ + "static/media/Lato.1031840a.woff2";